import React from 'react';
import { useParams } from 'react-router-dom';

import { Heading, Text } from '@eluve/components';

import { PromptTemplateUsers } from './PromptTemplateUsers';

export interface PromptTemplateUsersPageProps {}

export const PromptTemplateUsersPage: React.FC<
  PromptTemplateUsersPageProps
> = () => {
  const { promptTemplateId } = useParams() as { promptTemplateId: string };
  return (
    <div>
      <Heading size="2xl" weight="semibold">
        Users
      </Heading>
      <Text weight="regular">
        These users currently have this prompt template set as their default
      </Text>
      <PromptTemplateUsers promptTemplateId={promptTemplateId} />
    </div>
  );
};
